export default __webpack_public_path__ + "static/media/06.8dc8da72.jpg";